'use strict';

import { Entity } from '../Entity';

export class IndMedicaid extends Entity {
  protected indMedicaidId;
  protected indMedicaidNumber;
  protected indMedicaidLevel;
  protected indMedicaidLisLevel;
  protected indMedicaidNotes;
  protected indMedicaidPlan;
  protected indMedicaidRenewal;
  protected vault;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indMedicaidId = data.indMedicaidId;
    this.indMedicaidNumber = data.indMedicaidNumber;
    this.indMedicaidPlan = data.indMedicaidPlan;
    this.indMedicaidLevel = data.indMedicaidLevel;
    this.indMedicaidLisLevel = data.indMedicaidLisLevel;

    if (data.indMedicaidRenewal) {
      const indMedicaidRenewal = data.indMedicaidRenewal.date.split(' ')[0].split('-');
      this.indMedicaidRenewal =
        indMedicaidRenewal[1] + '/' + indMedicaidRenewal[2] + '/' + indMedicaidRenewal[0];
    }
  }

  public getIndMedicaidId() {
    return this.indMedicaidId;
  }

  public getIndMedicaidNumber() {
    return this.indMedicaidNumber;
  }

  public setIndMedicaidNumber(indMedicaidNumber) {
    this.indMedicaidNumber = indMedicaidNumber;

    return this;
  }

  public getIndMedicaidLevel() {
    return this.indMedicaidLevel;
  }

  public getIndMedicaidLisLevel() {
    return this.indMedicaidLisLevel;
  }

  public getIndMedicaidNotes() {
    return this.indMedicaidNotes;
  }

  public getIndMedicaidPlan() {
    return this.indMedicaidPlan;
  }

  public getIndMedicaidRenewal() {
    return this.indMedicaidRenewal;
  }

  public getVault() {
    return this.vault;
  }
}
